<template>
  <div class="customer-rights">
    <h1>国易坊客户权益服务规定</h1>
    <p>北京国易坊教育科技有限公司（以下简称“国易坊”）为了更好的服务客户，支持客户开展业务，国易坊将依照协议及本规定向不同级别身份的客户提供相应权益服务。国易坊将依照与不同级别身份的客户签定的协议及本规定提供权益服务，并在客户后期开展相应业务所涉及的设计服务、内部资料、课件、书院运营帮扶等方面提供相应的权益服务支持。</p>

    <p>一、国易坊向客户提供的设计服务类权益，在协议有效期间及本规定次数范围内提供免费权益服务，除此之外提供的权益服务，客户应依据协议及本规定按次支付权益服务费用:</p>
    <ul>
      <li>1、客户每年度尊享完国易坊免费提供的权益服务后，如需要国易坊提供后续权益服务，则客户需要依据协议及本规定按会员价格按次支付权益服务费用，并于付费完成后方可享受国易坊提供的后续权益服务。</li>
      <li>2、客户要求国易坊提供的后续权益服务，不属于依据协议及本规定按客户级别身份包含在内免费权益服务。客户所需的后续权益服务部分应依据协议及本规定按会员价格按次支付权益服务费用。</li>
      <li>3、如果客户经国易坊同意退费，且国易坊保留客户国学文化导师身份，该客户确认依据协议及本规定的会员价格按其已经享受的权益服务费用扣减后的金额办理退费。</li>
      <li>4、如果客户经国易坊同意退费，且国易坊不保留客户国学文化导师身份，该客户确认依据协议及本规定的级别身份权益服务的差别，依照市场价格按其已经享受的权益服务费用扣减后的金额办理退费。</li>
    </ul>

    <p>二、国易坊向客户提供的内部信息资料、课件、视频的使用权，以及各类管理帮扶</p>
    <p>仅限于：在客户与国易坊签署的协议有效期内，由国易坊免费提供使用及帮扶。鉴于国易坊所提供的内部信息资料、课件、视频，以及各类管理帮扶等属于国易坊专属信息资料，并涉及到国易坊的核心商业秘密信息，以及知识产权的权益保护。因此，未经国易坊书面同意，该部分国易坊的专属信息资料仅限于客户自身学习研究使用，严禁用于客户以外涉及第三方的商业用途。客户一旦依照协议及本规定享受并使用了国易坊的专属信息资料，该客户确认并同意国易坊有权不再受理客户提出的任何退费申请及要求。</p>
    <p>客户不同级别身份权益服务的具体规定（见附表）：</p>
    <!-- <h2>国易坊权益说明表</h2> -->
    <div>
        <img style="width:100%;" src="@/static/images/1.jpg" alt="权益说明表">
        <img style="width:100%;" src="@/static/images/2.jpg" alt="权益说明表">
    </div>

    <p style="text-align: end;">北京国易坊教育科技有限公司</p>
    <p style="text-align: end;padding-right: 30px;">2025 年 1 月 1 日</p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPage',
  data() {
    return {
      rightsTable: []
    };
  }
};
</script>

<style scoped>
.customer-rights {
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

h1, h2 {
  color: #333;
  text-align: center;
  font-size: 16px;
}

p, ul, table {
  color: #666;
  font-size: 12px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f4f4f4;
  color: #333;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

tr:hover {
  background-color: #f1f1f1;
}
</style>